import type { FC } from 'react';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { JavaBasicsWrapper } from './JavaBasics.styled';

interface JavaBasicsProps {}

const JavaBasics: FC<JavaBasicsProps> = () => (
 <JavaBasicsWrapper>
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Java Basics</h1>			
   </header>
   <div className="entry-content clear" itemProp="text">
      <p className="text-align-justify">The main purpose of programming is to automate a task on a computer to solve a problem, by providing a sequence of instructions. It is the implementation of logic to facilitate specified computing operations and functionality.</p>
      <br/>
      <p className="text-align-justify">In this section of our training, we will be covering the following topics :</p>
      <ul className="text-align-justify">
         <li><a href="/programming-language">Programming language</a></li>
         <li><a href="/data-types">Data Types</a></li>
         <li><a href="/keywords-variables">Keywords &amp; Variables</a></li>
         <li><a href="/recursion">Recursion</a></li>
      </ul>
      <br />
      <EmbedYoutube videoType="video" videoList={["wMAEa2U_03k"]} />

   </div>
</JavaBasicsWrapper>
);

export default JavaBasics;
